import React from "react";

const Glass = ({ value = 50 }) => {
  const amount = [
    <path
      d="M43.265 93.0715C24.0461 96.425 6.35371 85.9283 6.52665 86.1389C11.9179 92.7933 18.0835 99.8689 41.0093 99.9967C63.1381 100.117 69.2135 95.6656 74.0483 88.0863C74.6273 87.1765 57.0702 90.6578 43.265 93.0715Z"
      fill="#C3B3C9"
    />,

    <path
      d="M80.4822 79.437C70.971 84.1513 57.7753 90.858 43.8054 89.843C16.7377 87.8731 15.0685 77.9634 2.79785 81.3468C2.79785 81.3468 4.89559 85.0385 5.05349 85.2415C11.0685 91.6325 18.9257 100.858 41.5196 101.121C63.6474 101.369 74.031 91.4896 78.858 83.9031C79.5148 82.4589 80.0579 80.9657 80.4822 79.437Z"
      fill="#C3B3C9"
    />,
    <path
      d="M80.6506 71.5648C80.5904 71.1438 80.5002 70.7302 80.4174 70.3167L79.9288 67.6175C70.4251 76.0009 57.1468 82.8656 43.1693 81.0535C16.1017 77.5498 14.44 59.9107 2.16183 65.9408L1.40995 70.3167C1.32724 70.7302 1.23716 71.1438 1.18453 71.5648L1.00391 72.5497H1.10927C1.07168 73.0309 1.00391 73.4971 1.00391 73.9783C1.00391 88.9708 18.8761 101.121 40.9137 101.121C62.9513 101.121 80.8235 88.9708 80.8235 73.9783C80.8235 73.4971 80.7557 73.0309 80.7181 72.5497H80.8235L80.6506 71.5648Z"
      fill="#C3B3C9"
    />,
    <path
      d="M81.8478 72.6772C81.7951 72.2562 81.7051 71.8426 81.6224 71.4291L78.6148 55.0005C71.0961 61.2637 58.442 65.5268 50.2766 65.0982C36.9758 64.3463 18.0436 46.9178 5.7729 52.9404L2.58475 71.4291C2.50205 71.8426 2.41178 72.2562 2.35163 72.6772L2.17871 73.6697H2.28408C2.24648 74.1433 2.17871 74.617 2.17871 75.0982C2.17871 90.0832 20.0434 102.241 42.0885 102.241C64.1336 102.241 81.9983 90.0832 81.9983 75.0982C81.9983 74.617 81.9305 74.1433 81.8929 73.6697H81.9983L81.8478 72.6772Z"
      fill="#C3B3C9"
    />,
    <path
      d="M81.552 72.1211C81.4994 71.7 81.4093 71.2864 81.3266 70.8729L75.6497 37.9181C68.1309 44.1812 55.0105 45.8805 46.2211 43.1812C33.4767 39.3166 22.0256 22.9782 9.75495 29.0082L2.31913 70.8428C2.23642 71.2563 2.14615 71.6699 2.086 72.0909L1.91309 73.076V74.5045C1.91309 89.4969 19.7778 101.647 41.8229 101.647C63.868 101.647 81.7327 89.4969 81.7327 74.5045V73.076L81.552 72.1211Z"
      fill="#C3B3C9"
    />,
  ];

  const amountSvg = amount[Math.floor(value / 20)];

  return (
    <svg
      width="83"
      height="171"
      viewBox="0 0 83 171"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      alt="Image, icon of glass of red wine"
    >
      <path
        d="M41.7532 169.655C60.1405 169.655 75.0464 164.797 75.0464 158.805C75.0464 152.813 60.1405 147.956 41.7532 147.956C23.3658 147.956 8.45996 152.813 8.45996 158.805C8.45996 164.797 23.3658 169.655 41.7532 169.655Z"
        fill="white"
      />
      <path
        d="M41.6554 169.918C23.1516 169.918 8.10645 164.933 8.10645 158.805C8.10645 152.678 23.1441 147.7 41.6554 147.7C60.1666 147.7 75.2043 152.685 75.2043 158.805C75.2043 164.926 60.1366 169.918 41.6554 169.918ZM41.6554 148.219C23.4449 148.219 8.6252 152.971 8.6252 158.805C8.6252 164.64 23.4449 169.399 41.6554 169.399C59.8659 169.399 74.6855 164.647 74.6855 158.805C74.6855 152.963 59.8508 148.219 41.6554 148.219Z"
        fill="#212121"
      />
      <path
        d="M41.6553 170.67C24.7907 170.67 7.35449 166.234 7.35449 158.813C7.35449 151.392 24.7907 146.948 41.6553 146.948C58.5199 146.948 75.9561 151.384 75.9561 158.813C75.9561 166.241 58.4974 170.67 41.6553 170.67ZM41.6553 148.971C22.347 148.971 9.377 154.061 9.377 158.813C9.377 163.565 22.347 168.647 41.6553 168.647C60.9636 168.647 73.9336 163.557 73.9336 158.813C73.9336 154.068 60.9485 148.971 41.6553 148.971Z"
        fill="#212121"
      />
      <path
        d="M40.136 156.444H43.1436L43.1436 101.903H40.136L40.136 156.444Z"
        fill="white"
      />
      <path
        d="M39.0087 156.572C38.3846 156.572 37.8809 156.46 37.8809 156.317V102.031C37.8809 101.888 38.3846 101.775 39.0087 101.775C39.6327 101.775 40.1365 101.888 40.1365 102.031V156.317C40.1515 156.46 39.6252 156.572 39.0087 156.572Z"
        fill="#212121"
      />
      <path
        d="M43.911 156.572C43.287 156.572 42.7832 156.46 42.7832 156.317V102.031C42.7832 101.888 43.287 101.775 43.911 101.775C44.5351 101.775 45.0388 101.888 45.0388 102.031V156.317C45.0238 156.46 44.5125 156.572 43.911 156.572Z"
        fill="#212121"
      />
      <path
        d="M81.6322 73.106L81.4592 72.1211C81.3991 71.7001 81.3088 71.2865 81.2261 70.873L69.8804 10.2565C67.8954 5.4144 56.0232 1.68506 41.6398 1.68506C27.2563 1.68506 15.3768 5.44447 13.3918 10.2565L2.04569 70.873C1.96299 71.2865 1.87291 71.7001 1.82028 72.1211L1.63965 73.106H1.74501C1.70742 73.5872 1.63965 74.0534 1.63965 74.5346C1.63965 89.5271 19.5496 101.677 41.6398 101.677C63.73 101.677 81.6322 89.5271 81.6322 74.5346C81.6322 74.0534 81.5644 73.5872 81.5268 73.106H81.6322Z"
        fill="white"
      />
      {amountSvg}
      <path
        d="M41.6554 18.858C27.7231 18.858 15.4449 15.6324 13.084 11.3392L13.5425 11.0911C15.7982 15.2114 27.8962 18.3091 41.648 18.3091C58.1518 18.3091 69.6779 15.3016 69.6779 10.9858H70.1967C70.2268 16.4294 55.896 18.858 41.6554 18.858Z"
        fill="#212121"
      />
      <path
        d="M41.6549 19.61C27.2413 19.61 14.9482 16.2943 12.437 11.7304L12.0684 11.0687L13.8427 10.0913L14.2039 10.753C16.3167 14.58 28.3767 17.5875 41.6549 17.5875C59.3691 17.5875 68.9329 14.1965 68.9329 11.0086V10.2567H70.9557V11.0086C70.9783 17.3544 55.1887 19.61 41.6549 19.61Z"
        fill="#212121"
      />
      <path
        d="M41.6556 101.941C19.4526 101.941 1.39258 89.6473 1.39258 74.5346C1.39258 74.0308 1.72326 71.2564 1.80596 70.8203L13.1517 10.2039C15.2419 5.0986 27.2195 1.42188 41.6556 1.42188C56.0916 1.42188 68.069 5.09856 70.1366 10.1587V10.2039L81.4827 70.8279C81.573 71.2564 81.8961 74.0308 81.8961 74.5346C81.8961 89.6473 63.836 101.941 41.6556 101.941ZM41.6556 1.94063C27.6556 1.94063 15.618 5.54969 13.6481 10.3467L2.31737 70.9106C2.24219 71.3015 1.91867 74.0609 1.91867 74.5271C1.91867 89.3541 19.7458 101.414 41.6556 101.414C63.5653 101.414 81.3924 89.3842 81.3924 74.5271C81.3924 74.0609 81.0691 71.3015 80.9864 70.9181L69.648 10.3241C67.6405 5.55718 55.6179 1.94815 41.6556 1.94815V1.94063Z"
        fill="#212121"
      />
      <path
        d="M41.6555 102.692C19.039 102.692 0.640625 90.0608 0.640625 74.5345C0.640625 73.9706 0.97132 71.1661 1.06906 70.6774L12.4299 9.99324V9.9256C14.6855 4.47447 26.6555 0.669922 41.6254 0.669922C56.5953 0.669922 68.5878 4.42931 70.8058 9.87291L70.8661 10.0684L82.2118 70.6849C82.2945 71.1135 82.6329 73.9405 82.6329 74.5345C82.6479 90.0608 64.2494 102.692 41.6555 102.692ZM14.3698 10.5722L3.09157 71.0608C3.00887 71.4518 2.70058 74.151 2.70058 74.5345C2.70058 88.948 20.1894 100.67 41.6856 100.67C63.1818 100.67 80.6706 88.948 80.6706 74.5345C80.6706 74.1586 80.3623 71.4518 80.2796 71.0684L68.9562 10.5496C67.0014 6.14361 55.069 2.69996 41.6856 2.69996C28.3021 2.69996 16.2795 6.15115 14.3547 10.5722H14.3698Z"
        fill="#212121"
      />
    </svg>
  );
};

export default Glass;
